import { PieTileWidgetsService } from './pie-tile-widget.service';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ViewEncapsulation, Input, AfterViewInit } from '@angular/core';
declare var pg: any;
declare var echarts: any;

@Component({
  selector: 'pie-tile-widget',
  templateUrl: './pie-tile-widget.component.html',
  styleUrls: ['./pie-tile-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PieTileWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
  chartOptions;
  timeout;
  // ejemplo objeto chartData--> {key: "Masculino", value: 42 }
  chartData = [];

  @Input() AdditionalColorCard = "gray" ;
  @Input() title = "Title , " ;
  @Input() value = "-" ;
  @Input() detail = " *****" ;
  @Input() functionData = "Unknow" ;

  query; // sentencia query para obtener datos
  loading = false;
  _title = "" ;
  _value = "" ;
  _detail = "" ;

  constructor(private pieTileWidgetsService: PieTileWidgetsService) {
  }

  ngOnInit() {
    this.loading = true;
    this.pieTileWidgetsService.getFunctionByName(this.functionData)
    .toPromise().then( (res: any ) => { this.query = res.query; } )
    .then( () => {this.getData(); })
    .catch ( err => {
      console.log(err);
      this.loading = false;
    } );
  }
  getData() {
    this.loading = true;
    const args = { param: {}, query: this.query };
    this.pieTileWidgetsService.getData(args).toPromise()
    .then (async (res: any) => {
        await this.buildArrData(res);
        this.loading = false;
    })
    .catch ( err => {
    this.loading = false;
    console.log(err); 
    } );
  }

  buildArrData( arrOriginal: any[]) {
    return new Promise (resolve => {
      let total = 0;
      let mayorValue = 0 ;
      let mayorKey = '' ;
      this.chartData = arrOriginal.map (item => {
        // acumular valores e identificar mayor key y valor
        total += item[1] ;
        if (item[1] > mayorValue) {
          mayorKey = item[0] ;
          mayorValue = item[1];
        }
        return  {key : item[0] , value : item[1] };
      } );
      this._detail = `${mayorValue} de ${total.toString()}${this.detail}`;
      this._value = ((mayorValue  / total ) * 100).toFixed(2).toString() +  this.value ;
      this._title = `${this.title}${mayorKey}`;
      // console.log('fin carga de datos')
      resolve(); // condicion para indicar que la promesa termino, sino se envia queda en espera
    });
  }

  ngOnDestroy(){
    clearTimeout(this.timeout);
  }

  ngAfterViewInit() {
    this.timeout = setTimeout(()=>{
      this.chartOptions = {
        chart: {
          type: 'pieChart',
          height: 200,
          x(d) { return d.key; }, // x: function(d) {return d.key;}
          y(d) { return d.value; },
          showLabels: false,
          showLegend: false,
          duration: 500,
          labelThreshold: 0.01,
          labelSunbeamLayout: true,
          margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
        }
      }
    }, 2000);
  }

  onRefresh() {
    this.getData();
  }
}
